import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="sv-footer" data-testid="main-footer">
      <div className="container-x">
        <div className="sv-footer-grid">
          <div>
            <img
              src="/somveil-wordmark-reverse.png"
              alt="Somveil"
              className="sv-logo-img"
              style={{ height: 30, marginBottom: 18 }}
            />
            <p style={{ fontSize: 14, lineHeight: 1.55, color: "rgba(255,255,255,0.5)", maxWidth: 320 }}>
              India&apos;s sleep apnea discovery platform. We don&apos;t diagnose. We help you find out whether it&apos;s time to get tested — and then connect you with a verified specialist near you.
            </p>
          </div>
          <div>
            <h4>Product</h4>
            <Link to="/quiz">OSA Risk Quiz</Link>
            <Link to="/doctors">Find a specialist</Link>
            <Link to="/book">Book a sleep study</Link>
          </div>
          <div>
            <h4>Company</h4>
            <Link to="/about">About us</Link>
            <Link to="/login">Doctor login</Link>
          </div>
          <div>
            <h4>Legal</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
          </div>
        </div>
        <div className="sv-footer-bot">
          <span>Not a medical device. Not a diagnostic service.</span>
        </div>
        <div
          data-testid="footer-hmh-attribution"
          style={{
            marginTop: 16,
            paddingTop: 16,
            borderTop: "1px solid rgba(255,255,255,0.06)",
            textAlign: "center",
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 11,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,0.45)",
            whiteSpace: "nowrap",
          }}
        >
          Somveil &nbsp;·&nbsp; A{" "}
          <a
            href="https://www.hmhlabz.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-hmh-link"
            style={{
              display: "inline",
              color: "#4FBEBE",
              textDecoration: "none",
              borderBottom: "1px solid rgba(79,190,190,0.35)",
              paddingBottom: 1,
              transition: "color 0.2s, border-color 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#7AD4D4";
              e.currentTarget.style.borderBottomColor = "#7AD4D4";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#4FBEBE";
              e.currentTarget.style.borderBottomColor = "rgba(79,190,190,0.35)";
            }}
          >
            HMH Labz LLP
          </a>{" "}
          Unit
        </div>
      </div>
    </footer>
  );
}
